// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var MOBILE_PHONE_ATTR_NAME = "sequent.read-only.mobile-number";
export var EMAIL_AND_OR_MOBILE_ATTR_NAME = "emailAndOrMobile";
/**
 * Fields an admin with voter-email-tlf-edit but without voter-write may
 * change. Harvest's edit_user enforces the same set (EMAIL_TLF_ATTRIBUTES in
 * harvest routes/users.rs) and rejects anything else.
 */
export var EMAIL_TLF_FIELDS = new Set([
    "email",
    MOBILE_PHONE_ATTR_NAME,
    EMAIL_AND_OR_MOBILE_ATTR_NAME,
]);
/** Whether the voter form lets the current admin change `field`. */
export var canEditVoterField = function (access, field) {
    if (access.createMode || !access.electionEventId) {
        return true;
    }
    if (access.hasVoted && !access.canEditVotersWhoVoted) {
        return false;
    }
    if (access.canEditVoters) {
        return true;
    }
    return access.canEditVotersEmailTlf && EMAIL_TLF_FIELDS.has(field);
};
